/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { createSelector } from "reselect";

export const getNotification = (state) => state.notification;
export const getPendingUserNotif = createSelector(
  [getNotification],
  (notifications) => notifications?.pendingUserNotificaiton,
);
export const getTrialPeriodNotif = createSelector(
  [getNotification],
  (notifications) => notifications?.trialNotification,
);
export const getDismissed = createSelector(
  [getNotification],
  (notifications) => notifications?.dismissed,
);
